"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EditableSettingsList = require("../EditableSettingsList");
var _contexts = require("../contexts");
var _useSettingSection = _interopRequireDefault(require("../settingsHooks/useSettingSection"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Importing directly here to avoid cyclic dependency

const SettingPage = _ref => {
  let {
    allowEdit = true,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    sectionName
  } = _ref;
  const {
    settingEndpoint
  } = (0, _react.useContext)(_contexts.SettingsContext);
  const {
    handleSubmit,
    settings
  } = (0, _useSettingSection.default)({
    sectionName,
    settingEndpoint
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditableSettingsList.EditableSettingsList, {
    allowEdit: allowEdit,
    initialValues: {
      'settings': settings
    },
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides: labelOverrides,
    onSave: handleSubmit,
    onSubmit: handleSubmit,
    settingSection: sectionName
  });
};
SettingPage.propTypes = {
  allowEdit: _propTypes.default.bool,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  sectionName: _propTypes.default.string
};
var _default = exports.default = SettingPage;